export interface CustomerPortal {
    id: string;
    pricingPageId: string;
    business_profile: BusinessProfile;
    default_return_url?: string;
    features: Features;
    designSettings: CustomerPortalDesignSettings;
    secureMode: boolean;
    emailAuth: boolean;
    emailAuthTemplate?: EmailAuthTemplate;
    //These are from the backend once it is saved (only used for display)
    createdAt?: string;
    pricingPageName?: string;
    mode?: 'test' | 'live';
}
interface EmailAuthTemplate {
    subject: string;
    body: string;
    sender?: string;
    senderEmail?: string;
}

export interface BusinessProfile {
    company?: string;
    headline?: string;
    privacy_policy_url: string;
    terms_of_service_url: string;
}

export interface Features {
    customer_update: CustomerUpdate;
    invoice_history: InvoiceHistory;
    payment_method_update: PaymentMethodUpdate;
    subscription_cancel: SubscriptionCancel;
    subscription_pause: SubscriptionPause;
    subscription_update: SubscriptionUpdate;
}

export interface CustomerUpdate {
    allowed_updates?: { email: boolean; address: boolean; shipping: boolean; phone: boolean; tax_id: boolean };
    enabled: boolean;
}

export interface InvoiceHistory {
    enabled: boolean;
}
export interface PaymentMethodUpdate {
    enabled: boolean;
}

export interface SubscriptionPause {
    enabled: boolean;
}

export enum CANCELLATION_PRORATION_BEHAVIOUR {
    NONE = 'none',
    CREATE_PRORATIONS = 'create_prorations',
}

export enum CANCELLATION_MODE {
    IMMEDIATELY = 'immediately',
    PERIOD_END = 'at_period_end',
}

export const CANCELLATION_REASON_OPTIONS = [
    'customer_service',
    'low_quality',
    'missing_features',
    'switched_service',
    'too_complex',
    'too_expensive',
    'unused',
    'other',
];

export enum CANCELLATION_REASON_COLLECTION_MODE {
    BEFORE = 'before',
    AFTER = 'after',
}

export type CancellationReason = (typeof CANCELLATION_REASON_OPTIONS)[number];
export interface SubscriptionCancel {
    enabled: boolean;
    mode: CANCELLATION_MODE;
    proration_behavior: CANCELLATION_PRORATION_BEHAVIOUR;
    cancellation_reason: {
        enabled: boolean;
        options: CancellationReason[];
        mode: CANCELLATION_REASON_COLLECTION_MODE;
        refresh: boolean;
    };
}

export enum SUBSCRIPTION_UPDATE_PRORATION {
    NONE = 'none',
    PRORATION = 'create_prorations',
    ALWAYS_INVOICE = 'always_invoice',
}

export interface DisabledProduct {
    product: string;
    price: string;
}
export interface SubscriptionUpdate {
    default_allowed_updates: { price: boolean; quantity: boolean; promotion_code: boolean };
    enabled: boolean;
    proration_behavior: SUBSCRIPTION_UPDATE_PRORATION;
    disabled_products: DisabledProduct[];
}

export enum CustomerPortalButtonSize {
    SMALL = 'small',
    MEDIUM = 'medium',
    LARGE = 'large',
}

export enum CustomerPortalLayout {
    HORIZONTAL = 'horizontal',
    VERTICAL = 'vertical',
}

interface CustomerPortalMessages {
    checkEmail: string;
    invalidEmail: string;
}

interface CustomerPortalCustomWording {
    cancelSubscription?: string;
}

export interface CustomerPortalDesignSettings {
    buttonText: string;
    placeholderText: string;
    messages: CustomerPortalMessages;
    buttonColour: string;
    buttonSize: CustomerPortalButtonSize;
    layout: CustomerPortalLayout;
    customCSS?: string;
    customWording: CustomerPortalCustomWording;
}
